<template>
  <svg
    width="12px"
    height="12px"
    viewBox="0 0 44 44"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    v-bind="$attrs"
  >
    <title>icon-搜索</title>
    <g
      id="咨询头部整理优化"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="咨询活动-咨询预沟通"
        transform="translate(-590.000000, -119.000000)"
      >
        <g id="编组-4" transform="translate(0.000000, 96.000000)">
          <g id="icon-搜索" transform="translate(590.000000, 23.000000)">
            <rect id="矩形" x="0" y="0" width="44" height="44"></rect>
            <g
              id="搜索_search-(1)"
              transform="translate(5.000000, 5.000000)"
              :stroke="color"
              stroke-linejoin="round"
              stroke-width="3"
            >
              <path
                d="M15.3287595,30.6574376 C23.7945628,30.6574376 30.6575189,23.7944997 30.6575189,15.3287188 C30.6575189,6.86293792 23.7945628,0 15.3287595,0 C6.86295612,0 0,6.86293792 0,15.3287188 C0,23.7944997 6.86295612,30.6574376 15.3287595,30.6574376 Z"
                id="路径"
              ></path>
              <line
                x1="26.3488751"
                y1="26.3488954"
                x2="34"
                y2="34"
                id="路径"
                stroke-linecap="round"
              ></line>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'svgSearchNew',
  props: {
    color: {
      type: String,
      default: '#000'
    }
  }
}
</script>
